module.exports = "/_next/static/fonts/NewSpiritCondensed-Bold-4ce7c849ce832e285581e213a8db2ca5.woff2";